// appSettings namespace — logged-in Settings page (Settings.tsx).
// Keys mirror pl/appSettings.ts exactly. Professional product English.
export const appSettings = {
  nav: {
    profil: 'Profile',
    powiadomienia: 'Notifications',
    konto: 'Account',
    jezyk: 'Language & region',
    danger: 'Delete account',
    logout: 'Sign out',
  },
  profil: {
    heading: 'Profile',
    sub: 'How we address you in the app and in emails.',
    nameCardTitle: 'Name',
    nameCardSub: 'We use it in notifications. It is not public.',
    nameLabel: 'Artist or label name',
    nameHint: 'Up to 80 characters. You can change it any time.',
    save: 'Save',
    unsaved: 'Unsaved changes',
    savedWord: 'Saved',
    saveFailedWord: 'Saving failed. Try again.',
    nameHintShort: 'Up to 80 characters.',
    saving: 'Saving…',
    saved: 'Saved.',
    clear: 'Remove name',
    failed: 'Could not save. Try again.',
  },
  powiadomienia: {
    heading: 'Notifications',
    cardTitle: 'Emails you can switch off',
    cardSub: 'We send them to {email}.',
    notify_render: 'Edit ready',
    notify_publish: 'Publishing',
    notify_product: 'What’s new in EDIMI',
    saved: 'Saved.',
    failed: 'Could not save that setting. Try again.',
    billing: 'Invoices and payments',
    billingSub: 'price or terms changes, account security',
    always: 'always',
    alwaysTitle: 'Emails that cannot be switched off',
  },
  konto: {
    heading: 'Account',
    sub: 'Your email address and sign-in password for EDIMI.',
    emailCardTitle: 'Email address',
    emailCardSub: 'We send invoices and notifications to this address.',
    emailLabel: 'Email',
    verified: 'verified',
    unverified: 'unverified',
    emailChangeFoot: 'We’ll email a confirmation link to the new address; the change applies after you click it.',
    resend: 'Resend link',
    changeEmail: 'Change email',
    changePassword: 'Change password',
    devices: 'Other devices',
    signOut: 'Sign out',
    emailChangeSentShort: 'We sent a confirmation link to the new address.',
    newEmailLabel: 'New email address',
    newEmailPlaceholder: 'new@address.com',
    emailPwLabel: 'Confirm with your password',
    emailPwPlaceholder: 'Your password',
    emailChangeCancel: 'Cancel',
    emailChangeSubmit: 'Send confirmation link',
    emailChangeSending: 'Sending…',
    emailChangeSent: 'If the address is available, we’ve sent a confirmation link to it. Your current email stays active until you confirm.',
    emailChangeSame: 'This is already your current email address.',
    emailChangeInvalid: 'Enter a valid email address.',
    emailChangeFailed: 'Could not start the email change. Try again.',
    resendMsg: 'If an account exists and isn’t confirmed yet, we’ve sent a link.',
    pwCardTitle: 'Password',
    currentPwLabel: 'Current password',
    currentPwPlaceholder: 'Current password',
    newPwLabel: 'New password',
    newPwPlaceholder: 'New password',
    repeatPwLabel: 'Repeat new password',
    repeatPwPlaceholder: 'Repeat',
    pwFoot: 'You’ll stay signed in here; other devices will be signed out.',
    pwSaving: 'Saving…',
    pwUpdate: 'Update password',
    pwWeak: 'Password: at least 8 characters, including a capital letter and a number.',
    pwMismatch: 'New passwords don’t match.',
    pwUpdated: 'Password updated.',
    pwCurrentWrong: 'Your current password is incorrect.',
    pwTooWeak: 'Your new password is too weak.',
    pwFailed: 'Couldn’t change the password.',
    sessionsCardTitle: 'Active sessions',
    sessionsCardSub: 'Sign out of every other device with one click. You stay signed in here.',
    sessionsFoot: 'Don’t recognize a device? Sign the others out, then change your password.',
    signOutOthers: 'Sign out others',
    sessionsBusy: 'Signing out…',
    sessionsDone: 'All other devices have been signed out.',
    sessionsFailed: 'Could not sign the other devices out. Try again.',
  },
  jezyk: {
    heading: 'Language & region',
    sub: 'Affects the interface language and date format.',
    cardTitle: 'Interface language',
    polish: 'Polish',
    polishSub: 'Default',
    english: 'English',
    englishSub: 'Some messages may still be in Polish.',
    saved: 'Saved.',
    saveFailed: 'Couldn’t save the language.',
  },
  danger: {
    heading: 'Delete account',
    sub: 'Irreversible operations.',
    cardTitle: 'Delete account permanently',
    cardSub: 'We will delete your uploads, edits, and profile data. Billing records are retained only as long as tax law requires.',
    rowTitle: 'Permanent account deletion',
    rowSub: 'This operation cannot be undone. Unused tokens are forfeited.',
    deleteBtn: 'Delete account',
    confirmBody: 'Unused tokens are lost.',
    confirmLabel: 'Confirm with your password',
    confirmPlaceholder: 'Your current password',
    cancel: 'Cancel',
    confirmBtn: 'Delete account permanently',
    busy: 'Deleting…',
    wrongPassword: 'Incorrect password.',
    failed: 'Could not delete the account. Try again or email kontakt@edimi.ai.',
  },
}
